import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import React from "react";
import theme from "../../assets/theme";


export interface MultiSelectorOptionInterface {
    value: string;
    label: string;
    tooltipText: string;
}

interface MultiSelectorProps {
    values: string[];
    setValues: (values: string[]) => void;
    options: MultiSelectorOptionInterface[];
}
const MultiSelector = (props: MultiSelectorProps) => {
    const handleSelect = (
        event: React.MouseEvent<HTMLElement>,
        newTypes: string[],
    ) => {
        props.setValues(newTypes);
    };

    return (
        <ToggleButtonGroup
            color="primary"
            value={props.values}
            onChange={handleSelect}
            size="small"
            sx={{
                "& .Mui-selected": {
                    color: "white !important",
                    background: `${theme.palette.primary.main} !important`,
                },
            }}
        >
            {
                props.options.map((option: MultiSelectorOptionInterface) =>
                    <Tooltip title={option.tooltipText} key={option.label}>
                        <ToggleButton
                            sx={{ minWidth: "40px", p: 0 }}
                            value={option.value}
                        >
                            {option.label}
                        </ToggleButton>
                    </Tooltip>
                )
            }
        </ToggleButtonGroup>
    );
}

export default MultiSelector;
